module.exports = __webpack_public_path__ + "img/equipment.a84e78a6.png";